import { useAuth } from '@slr/shared-library';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from 'configs';
import { useCallback } from 'react';
import { useSolution1UsersApi } from 'services/solution1/useSolution1UsersApi';
import { useOrganizationMembersApi } from 'services/user/useOrganizationMembersApi';
import { useOrganizationsApi } from 'services/user/useOrganizationsApi';
import { useUsersApi } from 'services/user/useUsersApi';
import {
  EnsureBusinessOrganizationOptions,
  ensureBusinessOrganization
} from './ensureBusinessOrganization';

export const useEnsureBusinessOrganization = (
  options?: EnsureBusinessOrganizationOptions
) => {
  const { findMembershipsOfUser } = useOrganizationMembersApi();
  const {
    createOrganizationStrict,
    getOrganizationStrict,
    changeOrganizationStrict
  } = useOrganizationsApi();
  const { getCurrentUserProfile: getSolution1UserProfile } =
    useSolution1UsersApi();
  const { getCurrentUserProfile: getUserProfile } = useUsersApi();
  const { refreshToken } = useAuth();
  const queryClient = useQueryClient();

  const runEnsure = useCallback(
    () =>
      ensureBusinessOrganization({
        findMembershipsOfUser,
        createOrganization: createOrganizationStrict,
        getOrganization: getOrganizationStrict,
        changeOrganization: changeOrganizationStrict,
        getSolution1UserProfile,
        getUserProfile,
        options
      }),
    [
      changeOrganizationStrict,
      createOrganizationStrict,
      findMembershipsOfUser,
      getOrganizationStrict,
      getSolution1UserProfile,
      getUserProfile,
      options
    ]
  );

  return useMutation({
    mutationFn: runEnsure,
    onSuccess: async (changed) => {
      if (changed) {
        refreshToken();
      }
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.findMembershipsOfUser]
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.getCurrentUserProfile]
      });
    }
  });
};
